import React, {Component} from 'react';
import {Link} from 'react-router';
import I18n from 'lib/i18n/i18n';
import Properties from "../properties";
import {dataAutomationAttr, dollarsWithoutCents, imageUrl, isMobile} from 'helpers/ApplicationHelper'
import PopupTooltipSuccessFee from "components/popups/popupTooltipSuccessFee";

class SpecialProperties extends Properties {
    constructor(props) {
        super(props);
    }

    banner() {
        const text = I18n.getString(`itemPage::pendingSale::banners::${this.props.shipBack ? 'shipBack' : 'sold'}::text`).replace(/{type}/, this.props.item.type);
        return (
            <div className={`banner ${this.props.shipBack ? 'ship-back' : 'sold'}`}>
                <p className="text">{text}</p>
                {this.saleDetails()}
            </div>
        );
    }

    saleDetails() {
        if (this.props.shipBack) return;
        const linkText = I18n.getString('itemPage::pendingSale::saleFormat::successFeesLink');
        const waved = this.props.item.evaluation_seller_fees < 0;
        const wavedClass = waved ? 'bold' : '';
        const isQuickSale = this.props.item.format === "quick_sale"; // Otherwise it's "auction"

        return (
            [
                <p className="price" key='price'>
                    <span>{I18n.getString(`itemPage::pendingSale::banners::sold::${ isQuickSale ? 'priceQuickSale' : 'priceAuction' }`)}</span>
                    <span>{dollarsWithoutCents(this.props.item.evaluation_after_buyer_fees)}</span>
                </p>,
                <p className="fees" key='fees'>
                    <a className='link' data-automation={dataAutomationAttr(linkText)} onClick={() => {
                        PopupTooltipSuccessFee.initPopup()}}>{linkText}</a>
                    <span className={wavedClass}>{waved ? 'Waived' : `(${this.props.item.seller_fees_in_percentages})`}</span>
                    <span>{waved ? '' : dollarsWithoutCents(this.props.item.evaluation_seller_fees)}</span>
                </p>,
            ]
        );
    }

    title() {
        return (
            <div className='title-container'>
                { !this.props.shipBack && <div className="tag">sold</div> }
                <h2 className="item-desc">{this.props.item.sale_desc || this.props.item.desc}</h2>
            </div>
        );
    }

    render() {
        const mobile = isMobile();
        return (
            <div id="qs-properties">
                <Link to='/items' target="_self" className="link">
                    <img src={ imageUrl('item/little_arrow.svg') } />
                    {I18n.getString('itemPage::supportNegotiation::my_items')}
                </Link>
                { !mobile && this.title() || null }
                <div className='content-container'>
                    <div>
                        { this.banner() }
                    </div>
                    { mobile && this.title() || null }
                    <div>
                        { super.render() }
                    </div>
                </div>
            </div>
        )
    }
}

export default SpecialProperties;
